import React, { useState, useEffect } from 'react';
import { firestore } from '../../firebase/config';
import { doc, updateDoc } from 'firebase/firestore';
import '../../pages/Form.css'; // Garanta que este CSS contém os estilos para .animal-section, .animal-row, etc.
import { registrarAuditoria } from '../../services/auditoriaService';
import { useLocalidades } from '../../hooks/useLocalidades';

// OPCOES_LOCALIDADES removido — agora vem do Firestore via useLocalidades hook


function EditModal({ headerData, visita, agentsMap = {}, onClose, onSaveSuccess, currentUser }) {
  // Localidades carregadas dinamicamente do Firestore
  const { localidades: opcoesLocalidades } = useLocalidades();

  const [isEditing, setIsEditing] = useState(false);
  // A inicialização do estado agora garante que 'depositos', 'animais' e 'amostras' existam.
  const [formData, setFormData] = useState({ depositos: {}, animais: [], amostras: [], ...visita });

  // ▼▼▼ CÓDIGO PARA ADICIONAR ▼▼▼
  const [cicloSelecionado, setCicloSelecionado] = useState('');

  // Estados para cancelamento de visita
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [motivoCancelamento, setMotivoCancelamento] = useState('Visita duplicada');
  const [observacaoCancelamento, setObservacaoCancelamento] = useState('');
  
  // Estado de carregamento para evitar cliques múltiplos
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    // Quando o modal é aberto, extrai o número do ciclo da string 'ciclo/ano'
    if (visita.cicloAno && typeof visita.cicloAno === 'string') {
      const ciclo = visita.cicloAno.split('/')[0];
      setCicloSelecionado(ciclo);
    } else {
      setCicloSelecionado(''); // Define como vazio se não houver valor
    }
  }, [visita]); // Executa sempre que a visita selecionada mudar

  // Sincronizar formData com visita quando ela muda (ex: após cancelamento/reativação)
  useEffect(() => {
    setFormData({ depositos: {}, animais: [], amostras: [], ...visita });
  }, [visita.statusRegistro, visita.id]); // Atualiza quando status ou ID mudam


  // --- FUNÇÕES DE MANIPULAÇÃO DO FORMULÁRIO ---

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Lista dos campos <select> que NÃO devem ser convertidos
    const selectFields = ['visitaStatus', 'tipoImovel', 'temAnimais', 'depositoColeta', 'tipo', 'sexo'];

    let finalValue;

    if (type === 'checkbox') {
      finalValue = checked;

      // LÓGICA HÍBRIDA: Se o agente DESMARCAR o tratamento, limpa a lista
      if (name === 'tratFocalImovelTratado' && !checked) {
        setFormData(prev => ({ ...prev, tratamentosFocais: [] }));
      }
      if (name === 'tratPerifocalImovelTratado' && !checked) {
        setFormData(prev => ({ ...prev, tratamentosPerifocais: [] }));
      }

    } else if (selectFields.includes(name) || name.startsWith('animal-') || name.startsWith('amostra-')) {
      // Se for um select ou parte de uma lista dinâmica, usa o valor como está
      // (as funções específicas de lista dinâmica cuidam do 'toUpperCase' se necessário)
      finalValue = value;
    } else {
      // Para todos os outros campos (inputs de texto), converte para maiúsculas
      finalValue = String(value).toUpperCase();
    }

    // Lógica de atualização de estado (a sua lógica 'if/else' anterior)
    if (name.startsWith('dep-')) {
      const key = name.split('-')[1];
      setFormData(prev => ({ ...prev, depositos: { ...(prev.depositos || {}), [key]: Number(finalValue) || 0 } }));
    } else if (name.startsWith('animal-')) {
      const [, index, field] = name.split('-');
      const novosAnimais = [...(formData.animais || [])];
      novosAnimais[Number(index)][field] = finalValue;
      setFormData(prev => ({ ...prev, animais: novosAnimais }));
    } else if (name.startsWith('amostra-')) {
      const [, index, field] = name.split('-');
      const novasAmostras = [...(formData.amostras || [])];
      novasAmostras[Number(index)][field] = finalValue;
      setFormData(prev => ({ ...prev, amostras: novasAmostras }));
    } else {
      setFormData(prev => ({ ...prev, [name]: finalValue }));
    }
  };

  const adicionarAnimal = () => {
    setFormData(prev => ({
      ...prev,
      animais: [...(prev.animais || []), { tipo: 'CAO', sexo: 'MACHO', quantidade: 1 }]
    }));
  };

  const removerAnimal = (indexToRemove) => {
    setFormData(prev => ({
      ...prev,
      animais: prev.animais.filter((_, index) => index !== indexToRemove)
    }));
  };

  // Adiciona uma nova amostra (tubito) - LÓGICA INTELIGENTE (Mesma do AgenteDashboard)
  const adicionarAmostra = () => {
    // Identifica qual o primeiro depósito que possui quantidade > 0
    const tipos = ['A1', 'A2', 'B', 'C', 'D1', 'D2', 'E'];
    const mapping = {
      'A1': formData.depositos?.A1 || 0,
      'A2': formData.depositos?.A2 || 0,
      'B': formData.depositos?.B || 0,
      'C': formData.depositos?.C || 0,
      'D1': formData.depositos?.D1 || 0,
      'D2': formData.depositos?.D2 || 0,
      'E': formData.depositos?.E || 0
    };

    // Encontra o primeiro tipo valido
    const primeiroValido = tipos.find(t => Number(mapping[t]) > 0) || 'A1';

    setFormData(prev => ({
      ...prev,
      amostras: [
        ...(prev.amostras || []),
        {
          depositoColeta: primeiroValido, // Usa o encontrado ou 'A1' como fallback
          notaInicial: '',
          analise: {
            status: 'PENDENTE',
            aegypti: { larvas: 0, pupas: 0, adultos: 0, exuvia: 0 },
            albopictus: { larvas: 0, pupas: 0, adultos: 0, exuvia: 0 },
          }
        }
      ]
    }));
  };

  const removerAmostra = (indexToRemove) => {
    setFormData(prev => ({
      ...prev,
      amostras: prev.amostras.filter((_, index) => index !== indexToRemove)
    }));
  };

  const handleAmostraChange = (index, event) => {
    const { name, value } = event.target;
    const novasAmostras = [...(formData.amostras || [])];
    novasAmostras[index][name] = value;
    setFormData(prev => ({ ...prev, amostras: novasAmostras }));
  };

  // --- Funções para Tratamento FOCAL (Larvicida) ---
  const adicionarTratamentoFocal = () => {
    setFormData(prev => ({
      ...prev,
      tratamentosFocais: [
        ...(prev.tratamentosFocais || []),
        { depositoTratado: 'A1', tipoLarvicida: '', qtdeGramas: '' }
      ]
    }));
  };
  const removerTratamentoFocal = (indexToRemove) => {
    setFormData(prev => ({
      ...prev,
      tratamentosFocais: prev.tratamentosFocais.filter((_, index) => index !== indexToRemove)
    }));
  };
  const handleTratamentoFocalChange = (index, event) => {
    const { name, value } = event.target;
    const novosTratamentos = [...formData.tratamentosFocais];
    const finalValue = (name === 'qtdeGramas') ? value : String(value).toUpperCase();
    novosTratamentos[index][name] = finalValue;
    setFormData(prev => ({ ...prev, tratamentosFocais: novosTratamentos }));
  };

  // --- Funções para Tratamento PERIFOCAL (Adulticida) ---
  const adicionarTratamentoPerifocal = () => {
    setFormData(prev => ({
      ...prev,
      tratamentosPerifocais: [
        ...(prev.tratamentosPerifocais || []),
        { tipoAdulticida: '', qtdeGramas: '' }
      ]
    }));
  };
  const removerTratamentoPerifocal = (indexToRemove) => {
    setFormData(prev => ({
      ...prev,
      tratamentosPerifocais: prev.tratamentosPerifocais.filter((_, index) => index !== indexToRemove)
    }));
  };
  const handleTratamentoPerifocalChange = (index, event) => {
    const { name, value } = event.target;
    const novosTratamentos = [...formData.tratamentosPerifocais];
    const finalValue = (name === 'qtdeGramas') ? value : String(value).toUpperCase();
    novosTratamentos[index][name] = finalValue;
    setFormData(prev => ({ ...prev, tratamentosPerifocais: novosTratamentos }));
  };

  // --- FUNÇÃO PARA SALVAR AS ALTERAÇÕES ---

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (isSaving) return; // Previne múltiplos cliques
    setIsSaving(true);

    const { id, ...dataToUpdate } = formData;
    // ▼▼▼ CÓDIGO PARA ADICIONAR NO INÍCIO DA FUNÇÃO handleUpdate ▼▼▼
    if (cicloSelecionado) {
      const anoAtual = new Date().getFullYear();
      dataToUpdate.cicloAno = `${cicloSelecionado}/${anoAtual}`;
    } else {
      alert("Por favor, selecione um ciclo antes de salvar.");
      setIsSaving(false);
      return; // Impede o salvamento se o ciclo não for selecionado
    }

    // --- LÓGICA DE STATUS ADICIONADA ---
    // Gerencia o status da visita baseado na coleta de amostras
    if (dataToUpdate.coletaAmostra && dataToUpdate.amostras && dataToUpdate.amostras.length > 0) {
      // Verifica se todas as amostras já foram analisadas
      const todasAnalisadas = dataToUpdate.amostras.every(a => a.analise?.status?.toUpperCase() === 'CONCLUIDO');
      const algumaAnalisada = dataToUpdate.amostras.some(a => a.analise?.status?.toUpperCase() === 'CONCLUIDO');
      
      if (todasAnalisadas) {
        dataToUpdate.status = 'Análise Concluída';
      } else if (algumaAnalisada) {
        dataToUpdate.status = 'Análise Parcial';
      } else {
        dataToUpdate.status = 'Aguardando Análise';
      }
    } else {
      // Se desmarcou a coleta ou removeu todas as amostras
      dataToUpdate.status = 'Finalizado';
      dataToUpdate.coletaAmostra = false;
    }
    // ------------------------------------

    const visitDocRef = doc(firestore, 'relatoriosDiarios_FAD1', id);
    try {
      await updateDoc(visitDocRef, dataToUpdate);

      // --- LOG DE AUDITORIA ---
      // Comparamos 'visita' (estado original) com 'formData' (estado novo com as alterações)
      // Nota: dataToUpdate já contém as alterações processadas, mas formData é o estado mais fiel ao form visual.
      // Vamos usar uma combinação para garantir fidelidade.
      const dadosNovosCompleto = { ...visita, ...dataToUpdate };

      try {
        await registrarAuditoria(id, visita, dadosNovosCompleto, currentUser);
      } catch (auditError) {
        console.warn("Falha ao registrar auditoria (permissão ou erro):", auditError);
        // Não impedimos o fluxo de sucesso da edição, pois a visita já foi salva.
      }
      // -------------------------

      alert("Alterações salvas com sucesso!");
      setIsSaving(false);
      onSaveSuccess();
    } catch (error) {
      console.error("Erro ao atualizar:", error);
      alert("Falha ao salvar as alterações.");
      setIsSaving(false);
    }
  };

  // --- FUNÇÃO PARA CANCELAR VISITA ---
  const handleCancelVisit = async () => {
    if (!motivoCancelamento || !observacaoCancelamento.trim()) {
      alert("Por favor, preencha o motivo e a observação do cancelamento.");
      return;
    }

    const confirmacao = window.confirm(
      `Tem certeza que deseja CANCELAR esta visita?\n\nMotivo: ${motivoCancelamento}\nObservação: ${observacaoCancelamento}\n\nEsta ação pode ser revertida posteriormente.`
    );

    if (!confirmacao) return;

    const visitDocRef = doc(firestore, 'relatoriosDiarios_FAD1', formData.id);

    const dadosAntigos = { ...formData };
    const dadosCancelamento = {
      statusRegistro: motivoCancelamento === 'Visita duplicada' ? 'duplicado' : 'cancelado',
      motivoCancelamento,
      observacaoCancelamento,
      canceladoPor: currentUser?.email || 'desconhecido',
      canceladoPorNome: currentUser?.nome || currentUser?.email || 'Usuário',
      canceladoEm: new Date()
    };

    try {
      await updateDoc(visitDocRef, dadosCancelamento);

      // Registrar auditoria
      try {
        await registrarAuditoria(
          formData.id,
          dadosAntigos,
          { ...dadosAntigos, ...dadosCancelamento },
          currentUser
        );
      } catch (auditError) {
        console.warn("Falha ao registrar auditoria:", auditError);
      }

      alert("Visita cancelada com sucesso!");
      setShowCancelModal(false);
      onSaveSuccess();
    } catch (error) {
      console.error("Erro ao cancelar visita:", error);
      alert("Falha ao cancelar a visita.");
    }
  };

  // --- FUNÇÃO PARA REATIVAR VISITA ---
  const handleReactivateVisit = async () => {
    const confirmacao = window.confirm(
      "Tem certeza que deseja REATIVAR esta visita?\n\nEla voltará a aparecer em todos os relatórios e dashboards."
    );

    if (!confirmacao) return;

    const visitDocRef = doc(firestore, 'relatoriosDiarios_FAD1', formData.id);

    const dadosAntigos = { ...formData };
    const dadosReativacao = {
      statusRegistro: 'ativo',
      motivoCancelamento: null,
      observacaoCancelamento: null,
      canceladoPor: null,
      canceladoPorNome: null,
      canceladoEm: null,
      reativadoPor: currentUser?.email || 'desconhecido',
      reativadoPorNome: currentUser?.nome || currentUser?.email || 'Usuário',
      reativadoEm: new Date()
    };

    try {
      await updateDoc(visitDocRef, dadosReativacao);

      // Atualizar formData local para refletir mudanças imediatamente
      setFormData(prev => ({ ...prev, ...dadosReativacao }));

      // Registrar auditoria
      try {
        await registrarAuditoria(
          formData.id,
          dadosAntigos,
          { ...dadosAntigos, ...dadosReativacao },
          currentUser
        );
      } catch (auditError) {
        console.warn("Falha ao registrar auditoria:", auditError);
      }

      alert("Visita reativada com sucesso!");
      onSaveSuccess();
    } catch (error) {
      console.error("Erro ao reativar visita:", error);
      alert("Falha ao reativar a visita.");
    }
  };


  // --- MAPAS PARA EXIBIÇÃO (sem alterações)
  const visitaStatusMap = { 'INSPECIONADO': 'Inspecionado', 'RECUPERADO': 'Recuperado', 'RECUSA': 'Recusa', 'FECHADO': 'Fechado' };
  const tipoImovelMap = { 'R': 'Residência', 'C': 'Comércio', 'TB': 'Terreno baldio', 'O': 'Outros', 'PE': 'Ponto estratégico' };
  const atividadeMap = { '1': '1 - RA', '2': '2 - LI+T', '3': '3 - PE', '4': '4 - T', '5': '5 - DF', '6': '6 - PVE', '7': '7 - ID', '8': '8 - BT' };


  // Normalização Robustez para Status
  const statusRegistroNorm = formData.statusRegistro ? formData.statusRegistro.trim().toLowerCase() : 'ativo';
  const isCancelado = statusRegistroNorm !== 'ativo';

  // --- JSX DO COMPONENTE ---
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h4>{isEditing ? 'Editando Visita' : 'Detalhes da Visita'}</h4>

        {/* Badge de Status de Cancelamento */}
        {isCancelado && (
          <div style={{
            backgroundColor: '#dc3545',
            color: 'white',
            padding: '10px',
            borderRadius: '5px',
            marginBottom: '15px',
            textAlign: 'center'
          }}>
            <strong>⚠️ VISITA {formData.statusRegistro ? formData.statusRegistro.toUpperCase() : 'CANCELADO'}</strong>
            <p style={{ margin: '5px 0 0 0', fontSize: '0.9em' }}>
              Motivo: {formData.motivoCancelamento || 'Não especificado'}
            </p>
            <p style={{ margin: '5px 0 0 0', fontSize: '0.85em' }}>
              Cancelado por: {formData.canceladoPorNome || 'Desconhecido'} em {formData.canceladoEm?.toDate?.().toLocaleString('pt-BR') || 'Data não disponível'}
            </p>
            {formData.observacaoCancelamento && (
              <p style={{ margin: '5px 0 0 0', fontSize: '0.85em', fontStyle: 'italic' }}>
                &quot;{formData.observacaoCancelamento}&quot;
              </p>
            )}

          </div>
        )}

        {!isEditing ? (
          // --- MODO DE VISUALIZAÇÃO (sem alterações) ---
          <div className="review-modal">
            <div className="review-section">
              <h4>Cabeçalho da Atividade</h4>
              <p><strong>Município:</strong> {formData.municipio}</p>
              <p><strong>Localidade:</strong> {formData.localidade}</p>
              <p><strong>Ciclo/Ano:</strong> {formData.cicloAno}</p>
            </div>

            <div className="review-section">
              <h4>Detalhes da Inspeção</h4>
              <p><strong>Agente:</strong> {agentsMap[formData.idAgente] || formData.emailAgente}</p>
              <p><strong>Data:</strong> {formData.dataAtividade?.toDate().toLocaleString('pt-BR')}</p>
              <p><strong>Quarteirão:</strong> {formData.quarteirao}</p>
              <p><strong>Logradouro:</strong> {formData.logradouro}, Nº {formData.numeroImovel} {formData.complemento ? `(Comp: ${formData.complemento})` : ''}</p>
              <p><strong>Status:</strong> {visitaStatusMap[formData.visitaStatus]}</p>
              <p><strong>Tipo de Imóvel:</strong> {tipoImovelMap[formData.tipoImovel]}</p>
              <p><strong>Atividade:</strong> {atividadeMap[formData.atividade] || 'N/A'}{formData.atividade === '2' && formData.subAtividadeLIT && (` (${formData.subAtividadeLIT.li ? 'LI' : ''}${formData.subAtividadeLIT.li && formData.subAtividadeLIT.t ? '+' : ''}${formData.subAtividadeLIT.t ? 'T' : ''})`)}</p>
            </div>

            <div className="review-section">
              <h4>Depósitos</h4>
              <p>
                <strong>Inspec.:</strong>
                A1({formData.depositos?.A1 || 0}),
                A2({formData.depositos?.A2 || 0}),
                B({formData.depositos?.B || 0}),
                C({formData.depositos?.C || 0}),
                D1({formData.depositos?.D1 || 0}),
                D2({formData.depositos?.D2 || 0}),
                E({formData.depositos?.E || 0})
              </p>
              <p><strong>Eliminados:</strong> {formData.depositoEliminado || 0}</p>
            </div>

            {/* Seção de animais  */}
            <div className="review-section">
              <h4>Censo Animal</h4>

              {/* A verificação agora é mais simples e considera a caixa alta */}
              {formData.temAnimais === 'SIM' ? (
                <>
                  <p><strong>Possui animais?:</strong> Sim</p>
                  {/* Se a resposta for 'SIM', então mapeamos e mostramos a lista */}
                  {formData.animais?.length > 0 ? (
                    formData.animais.map((animal, index) => (
                      <p key={index} style={{ marginLeft: '1rem' }}>
                        - {animal.tipo} ({animal.sexo}): <strong>{animal.quantidade}</strong>
                      </p>
                    ))
                  ) : (
                    <p style={{ marginLeft: '1rem' }}><em>Nenhum animal foi especificado.</em></p>
                  )}
                </>
              ) : (
                // Se 'temAnimais' for 'NAO' ou qualquer outra coisa, exibe "Não"
                <p><strong>Possui animais?:</strong> Não</p>
              )}
            </div>

            <div className="review-section">
              <h4>Tratamento</h4>
              <p><strong>Focal (Larvicida):</strong> {formData.tratFocalImovelTratado ? 'Sim' : 'Não'}</p>
              {formData.tratFocalImovelTratado && formData.tratamentosFocais?.length > 0 && (
                formData.tratamentosFocais.map((trat, index) => (
                  <p key={index} style={{ marginLeft: '1rem' }}>- Dep. {trat.depositoTratado}: {trat.qtdeGramas}g de {trat.tipoLarvicida || 'N/I'}</p>
                ))
              )}
              <p style={{ marginTop: '10px' }}><strong>Perifocal (Adulticida):</strong> {formData.tratPerifocalImovelTratado ? 'Sim' : 'Não'}</p>
              {formData.tratPerifocalImovelTratado && formData.tratamentosPerifocais?.length > 0 && (
                formData.tratamentosPerifocais.map((trat, index) => (
                  <p key={index} style={{ marginLeft: '1rem' }}>- Tratamento {index + 1}: {trat.qtdeGramas}g de {trat.tipoAdulticida || 'N/I'}</p>
                ))
              )}
            </div>

            <div className="review-section">
              <h4>Coleta de Amostra</h4>
              <p><strong>Coleta realizada?:</strong> {formData.coletaAmostra ? 'Sim' : 'Não'}</p>
              {formData.coletaAmostra && formData.amostras?.length > 0 && (
                formData.amostras.map((amostra, index) => (
                  <p key={index} style={{ marginLeft: '1rem' }}>
                    - Dep. {amostra.depositoColeta} | Nota Obs: {amostra.notaInicial}
                  </p>
                ))
              )}
            </div>

            <div className="review-section">
              <h4>Localização GPS</h4>
              {formData.coordenadas ? (
                <a href={`https://maps.google.com/?q=${formData.coordenadas.latitude},${formData.coordenadas.longitude}`} target="_blank" rel="noopener noreferrer">
                  Ver no Mapa (Lat: {formData.coordenadas.latitude.toFixed(5)}, Long: {formData.coordenadas.longitude.toFixed(5)})
                </a>
              ) : (<p>Coordenadas não coletadas.</p>)}
            </div>

            <div className="review-section">
              <h4>Resultado do Laboratório</h4>

              {/* Passo 1: Verifica se houve coleta */}
              {formData.coletaAmostra ? (

                // Passo 2: Se houve coleta, mapeia as amostras (tubitos)
                formData.amostras?.length > 0 ? (
                  formData.amostras.map((amostra, index) => (
                    <div key={index} className="lab-result-item" style={{ borderTop: '1px solid #ddd', paddingTop: '10px', marginTop: '10px' }}>

                      <p><strong>Amostra {index + 1} (Depósito: {amostra.depositoColeta}, Nota Obs: {amostra.notaInicial})</strong></p>

                      {/* Passo 3: Verifica o status da ANÁLISE de cada amostra */}
                      {amostra.analise?.status === 'PENDENTE' ? (
                        <p style={{ marginLeft: '1rem' }}><em>Aguardando análise...</em></p>
                      ) : amostra.analise?.status === 'CONCLUIDO' ? (
                        <div style={{ marginLeft: '1rem' }}>
                          <p>Status: <strong>Análise Concluída</strong></p>
                          <p>Data: {amostra.analise.dataAnalise?.toDate().toLocaleDateString()}</p>
                          <p>
                            <strong>A. aegypti:</strong>
                            L({amostra.analise.aegypti?.larvas || 0}),
                            P({amostra.analise.aegypti?.pupas || 0}),
                            EP({amostra.analise.aegypti?.exuvia || 0}),
                            A({amostra.analise.aegypti?.adultos || 0})
                          </p>
                          <p>
                            <strong>A. albopictus:</strong>
                            L({amostra.analise.albopictus?.larvas || 0}),
                            P({amostra.analise.albopictus?.pupas || 0}),
                            EP({amostra.analise.albopictus?.exuvia || 0}),
                            A({amostra.analise.albopictus?.adultos || 0})
                          </p>
                        </div>
                      ) : (
                        <p style={{ marginLeft: '1rem' }}><em>Status da análise desconhecido.</em></p>
                      )}

                    </div>
                  ))
                ) : (
                  <p>Nenhuma amostra (tubito) registrada para esta visita.</p>
                )

              ) : (
                <p>Não houve coleta de amostra nesta visita.</p>
              )}
            </div>
            <div className="modal-actions">
              <button type="button" onClick={onClose}>Fechar</button>

              {/* Se a visita está cancelada, mostra botão de Reativar */}
              {isCancelado ? (

                <button
                  type="button"
                  className="edit-button"
                  onClick={handleReactivateVisit}
                  style={{ backgroundColor: '#28a745' }}
                >
                  ✓ Reativar Visita
                </button>
              ) : (
                <>
                  {/* Se a visita está ativa, mostra botões de Editar e Cancelar */}
                  <button
                    type="button"
                    className="edit-button"
                    onClick={() => setIsEditing(true)}
                  >
                    Editar
                  </button>
                  <button
                    type="button"
                    onClick={() => setShowCancelModal(true)}
                    style={{ backgroundColor: '#dc3545', color: 'white' }}
                  >
                    ✕ Cancelar Visita
                  </button>
                </>
              )}
            </div>

            {/* Modal de Cancelamento */}
            {showCancelModal && (
              <div className="modal-overlay" style={{ zIndex: 1001 }}>
                <div className="modal-content" style={{ maxWidth: '500px' }}>
                  <h4>⚠️ Cancelar Visita</h4>
                  <p style={{ color: '#666', marginBottom: '20px' }}>
                    Esta ação marcará a visita como cancelada. Ela não aparecerá mais nos relatórios e dashboards, mas poderá ser reativada posteriormente.
                  </p>

                  <div className="input-group" style={{ marginBottom: '15px' }}>
                    <label><strong>Motivo do Cancelamento:</strong></label>
                    <select
                      value={motivoCancelamento}
                      onChange={(e) => setMotivoCancelamento(e.target.value)}
                      style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
                    >
                      <option value="Visita duplicada">Visita duplicada</option>
                      <option value="Erro de lançamento">Erro de lançamento</option>
                      <option value="Visita inválida">Visita inválida</option>
                      <option value="Outro">Outro</option>
                    </select>
                  </div>

                  <div className="input-group" style={{ marginBottom: '20px' }}>
                    <label><strong>Observação (obrigatório):</strong></label>
                    <textarea
                      value={observacaoCancelamento}
                      onChange={(e) => setObservacaoCancelamento(e.target.value)}
                      placeholder="Explique o motivo do cancelamento..."
                      rows={4}
                      style={{
                        width: '100%',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #ddd',
                        resize: 'vertical'
                      }}
                      required
                    />
                  </div>

                  <div className="modal-actions">
                    <button
                      type="button"
                      onClick={() => {
                        setShowCancelModal(false);
                        setObservacaoCancelamento('');
                      }}
                    >
                      Voltar
                    </button>
                    <button
                      type="button"
                      onClick={handleCancelVisit}
                      style={{ backgroundColor: '#dc3545', color: 'white' }}
                    >
                      Confirmar Cancelamento
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          // --- MODO DE EDIÇÃO (com todos os campos) ---
          <form onSubmit={handleUpdate} className="edit-form">
            {/* --- Detalhes da Inspeção --- */}
            <fieldset>
              <legend>Cabeçalho da Atividade</legend>
              <div className="form-grid">
                <div className="input-group">
                  <label>Município</label>
                  {/* Deixando como apenas leitura, pois geralmente não muda */}
                  <input value={formData.municipio || ''} readOnly />
                </div>
                <div className="input-group">
                  <label>Localidade</label>
                  <select
                    name="localidade"
                    value={formData.localidade || ''}
                    onChange={handleInputChange}
                  >
                    <option value="">Selecione uma localidade</option>
                    {/* Caso a localidade salva não esteja na lista, adicionamos ela como opção extra para não quebrar a UI */}
                    {formData.localidade && !opcoesLocalidades.some(l => l.nome === formData.localidade) && (
                      <option value={formData.localidade}>{formData.localidade}</option>
                    )}
                    {opcoesLocalidades.map((localidade) => (
                      <option key={localidade.id} value={localidade.nome}>
                        {localidade.nome}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="input-group">
                  <label>Ciclo</label>
                  <select
                    name="ciclo" // O valor final é construído ao salvar
                    value={cicloSelecionado}
                    onChange={e => setCicloSelecionado(e.target.value)}
                    required
                  >
                    <option value="">Selecione</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                  </select>
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>Detalhes da Inspeção</legend>
              <div className="form-grid">
                <div className="input-group">
                  <label>Nº Sequência do Dia</label>
                  <input value={formData.sequencia || ''} readOnly />
                </div>
                <div className="input-group">
                  <label>Nº do quarteirão</label>
                  <input name="quarteirao" type="number" value={formData.quarteirao || ''} onChange={handleInputChange} required />
                </div>
                <div className="input-group grid-col-span-2">
                  <label>Nome do Logradouro</label>
                  <input name="logradouro" type="text" value={formData.logradouro || ''} onChange={handleInputChange} required />
                </div>
                <div className="input-group">
                  <label>Nº do Imóvel (Funasa)</label>
                  <input name="numeroImovel" type="text" value={formData.numeroImovel || ''} onChange={handleInputChange} required />
                </div>
                <div className="input-group">
                  <label>Complemento</label>
                  <input name="complemento" type="text" value={formData.complemento || ''} onChange={handleInputChange} />
                </div>
                <div className="input-group">
                  <label>Hora de Entrada</label>
                  <input name="horaEntrada" type="time" value={formData.horaEntrada || ''} onChange={handleInputChange} />
                </div>
                <div className="input-group">
                  <label>Status da Visita</label>
                  <select name="visitaStatus" value={formData.visitaStatus || ''} onChange={handleInputChange}>
                    <option value="">Selecione</option>
                    <option value="INSPECIONADO">Inspecionado</option>
                    <option value="RECUPERADO">Recuperado</option>
                    <option value="RECUSA">Recusa</option>
                    <option value="FECHADO">Fechado</option>
                  </select>
                </div>
                <div className="input-group">
                  <label>Tipo de Imóvel</label>
                  <select name="tipoImovel" value={formData.tipoImovel} onChange={handleInputChange}>
                    <option value="R">Residência</option>
                    <option value="C">Comércio</option>
                    <option value="TB">Terreno baldio</option>
                    <option value="O">Outros</option>
                    <option value="PE">Ponto estratégico</option>
                  </select>
                </div>
              </div>
            </fieldset>

            {/* --- Nº de Depósitos --- */}
            <fieldset>
              <legend>Nº de Depósitos</legend>
              <div className="form-grid deposits">
                <div className="input-group"><label>A1</label><input name="dep-A1" type="number" value={formData.depositos?.A1 || ''} onChange={handleInputChange} /></div>
                <div className="input-group"><label>A2</label><input name="dep-A2" type="number" value={formData.depositos?.A2 || ''} onChange={handleInputChange} /></div>
                <div className="input-group"><label>B</label><input name="dep-B" type="number" value={formData.depositos?.B || ''} onChange={handleInputChange} /></div>
                <div className="input-group"><label>C</label><input name="dep-C" type="number" value={formData.depositos?.C || ''} onChange={handleInputChange} /></div>
                <div className="input-group"><label>D1</label><input name="dep-D1" type="number" value={formData.depositos?.D1 || ''} onChange={handleInputChange} /></div>
                <div className="input-group"><label>D2</label><input name="dep-D2" type="number" value={formData.depositos?.D2 || ''} onChange={handleInputChange} /></div>
                <div className="input-group"><label>E</label><input name="dep-E" type="number" value={formData.depositos?.E || ''} onChange={handleInputChange} /></div>
                <div className="input-group"><label>Eliminados</label><input name="depositoEliminado" type="number" value={formData.depositoEliminado || ''} onChange={handleInputChange} /></div>
              </div>
            </fieldset>

            {/* --- Animais no Domicílio --- */}
            <fieldset>
              <legend>Animais no Domicílio</legend>
              <div className="input-group">
                <label>Possui cães ou gatos?</label>
                <select
                  name="temAnimais"
                  value={formData.temAnimais || ''}
                  onChange={handleInputChange}
                  required={formData.visitaStatus === 'INSPECIONADO' || formData.visitaStatus === 'RECUPERADO'}
                  disabled={formData.visitaStatus === 'RECUSA' || formData.visitaStatus === 'FECHADO'}
                >
                  <option value="">Selecione</option>
                  <option value="SIM">Sim</option>
                  <option value="NAO">Não</option>
                </select>
              </div>
              {formData.temAnimais === 'SIM' && (
                <div className="animal-section">
                  {formData.animais?.map((animal, index) => (
                    <div key={index} className="form-grid animal-row">
                      <div className="input-group">
                        <label>Tipo</label>
                        <select name={`animal-${index}-tipo`} value={animal.tipo} onChange={handleInputChange}>
                          <option value="CAO">Cão</option>
                          <option value="GATO">Gato</option>
                        </select>
                      </div>
                      <div className="input-group">
                        <label>Sexo</label>
                        <select name={`animal-${index}-sexo`} value={animal.sexo} onChange={handleInputChange}>
                          <option value="MACHO">Macho</option>
                          <option value="FEMEA">Fêmea</option>
                        </select>
                      </div>
                      <div className="input-group"><label>Quantidade</label><input name={`animal-${index}-quantidade`} type="number" min="1" value={animal.quantidade} onChange={handleInputChange} /></div>
                      <button type="button" className="remove-btn" onClick={() => removerAnimal(index)}>Remover</button>
                    </div>
                  ))}
                  <button type="button" className="add-btn" onClick={adicionarAnimal}>+ Adicionar Grupo</button>
                </div>
              )}
            </fieldset>

            {/* --- Coleta de Amostra --- */}
            <fieldset>
              <legend>Coleta de Amostra</legend>
              <div className="form-grid">
                <div className="checkbox-group grid-col-span-full">
                  <label>
                    <input name="coletaAmostra" type="checkbox" checked={formData.coletaAmostra || false} onChange={handleInputChange} /> Coleta amostra?
                  </label>
                </div>
              </div>

              {/* A lógica abaixo só aparece se a caixa acima for marcada */}
              {formData.coletaAmostra && (
                <div className="sample-section">
                  {formData.amostras?.map((amostra, index) => (
                    <div key={index} className="form-grid sample-row">
                      <div className="input-group">
                        <label>Depósito Coletado</label>
                        {/* Conectando o onChange para cada campo da amostra */}
                        <select name="depositoColeta" value={amostra.depositoColeta} onChange={(e) => handleAmostraChange(index, e)}>
                          <option value="">Selecione</option>
                          <option value="A1">A1</option>
                          <option value="A2">A2</option>
                          <option value="B">B</option>
                          <option value="C">C</option>
                          <option value="D1">D1</option>
                          <option value="D2">D2</option>
                          <option value="E">E</option>
                        </select>
                      </div>
                      <div className="input-group">
                        <label>Nota Obs</label>
                        <input name="notaInicial" type="text" value={amostra.notaInicial} onChange={(e) => handleAmostraChange(index, e)} />
                      </div>
                      {/* Conectando o botão Remover */}
                      <button type="button" className="remove-btn" onClick={() => removerAmostra(index)}>Remover</button>
                    </div>
                  ))}
                  {/* Conectando o botão Adicionar */}
                  <button type="button" className="add-btn" onClick={adicionarAmostra}>
                    + Adicionar Coleta
                  </button>
                </div>
              )}
            </fieldset>

            {/* --- Tratamento --- */}
            <fieldset>
              <legend>Tratamento</legend>
              <div className="form-grid">

                {/* --- Tratamento Focal --- */}
                <div className="checkbox-group grid-col-span-full">
                  <label>
                    <input
                      name="tratFocalImovelTratado"
                      type="checkbox"
                      checked={formData.tratFocalImovelTratado}
                      onChange={handleInputChange}
                    /> Imóvel tratado com Larvicida (Focal)?
                  </label>
                </div>

                {/* Só mostra a lista de tratamentos FOCAIS se o checkbox acima estiver marcado */}
                {formData.tratFocalImovelTratado && (
                  <div className="sample-section grid-col-span-full">
                    {formData.tratamentosFocais.map((tratamento, index) => (
                      <div key={index} className="form-grid sample-row">
                        <div className="input-group"><label>Depósito Tratado</label><select name="depositoTratado" value={tratamento.depositoTratado} onChange={(e) => handleTratamentoFocalChange(index, e)}><option value="A1">A1</option><option value="A2">A2</option><option value="B">B</option><option value="C">C</option><option value="D1">D1</option><option value="D2">D2</option><option value="E">E</option></select></div>
                        <div className="input-group"><label>Tipo de Larvicida</label><input name="tipoLarvicida" type="text" value={tratamento.tipoLarvicida} onChange={(e) => handleTratamentoFocalChange(index, e)} placeholder="Ex: TEMEFÓS" required /></div>
                        <div className="input-group"><label>Qtde. (gramas)</label><input name="qtdeGramas" type="number" step="0.1" min={0.1} value={tratamento.qtdeGramas} onChange={(e) => handleTratamentoFocalChange(index, e)} required /></div>
                        <button type="button" className="remove-btn" onClick={() => removerTratamentoFocal(index)}>Remover</button>
                      </div>
                    ))}
                    <button type="button" className="add-btn" onClick={adicionarTratamentoFocal}>+ Adicionar Tratamento Focal</button>
                  </div>
                )}

                {/* --- Tratamento Perifocal --- */}
                <div className="checkbox-group grid-col-span-full">
                  <label>
                    <input
                      name="tratPerifocalImovelTratado"
                      type="checkbox"
                      checked={formData.tratPerifocalImovelTratado}
                      onChange={handleInputChange}
                    /> Imóvel tratado com Adulticida (Perifocal)?
                  </label>
                </div>

                {/* Só mostra a lista de tratamentos PERIFOCAIS se o checkbox acima estiver marcado */}
                {formData.tratPerifocalImovelTratado && (
                  <div className="sample-section grid-col-span-full">
                    {formData.tratamentosPerifocais.map((tratamento, index) => (
                      <div key={index} className="form-grid sample-row">
                        <div className="input-group"><label>Tipo de Adulticida</label><input name="tipoAdulticida" type="text" value={tratamento.tipoAdulticida} onChange={(e) => handleTratamentoPerifocalChange(index, e)} placeholder="Ex: MALATHION" required /></div>
                        <div className="input-group"><label>Qtde. (gramas)</label><input name="qtdeGramas" type="number" step="0.1" min={0.1} value={tratamento.qtdeGramas} onChange={(e) => handleTratamentoPerifocalChange(index, e)} required /></div>
                        <button type="button" className="remove-btn" onClick={() => removerTratamentoPerifocal(index)}>Remover</button>
                      </div>
                    ))}
                    <button type="button" className="add-btn" onClick={adicionarTratamentoPerifocal}>+ Adicionar Tratamento Perifocal</button>
                  </div>
                )}
              </div>
            </fieldset>

            <div className="modal-actions">
              <button type="button" onClick={() => setIsEditing(false)} disabled={isSaving}>Cancelar</button>
              <button type="submit" disabled={isSaving}>
                {isSaving ? 'Salvando...' : 'Salvar Alterações'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default EditModal;